/**
 * @deprecated This configuration has been moved to `@vts/client-config` library.
 * Please use `import { routes } from '@vts/client-config/lib/routes/hardwareManagementRoutes'` instead.
 * This file will be removed in a future version.
 * @see {@link https://github.com/VTS-com/lane-next/tree/main/libs/client-config/src/lib/routes/hardwareManagementRoutes.ts}
 */
export const routes = {
  hardwareDevices: 'hardware-management/devices',
  hardwareAccessLogs: 'hardware-management/access-logs',
  hardwareDetails: 'hardware-management/hardware/:hardwareId',
  hardwareAdd: 'hardware-management/new',
  relayList: 'hardware-management/relays',
  relayDetails: 'hardware-management/relays/:relayId',
  hardwarePinCodes: 'hardware-management/pin-codes',
  hardwareAddPinCodes: 'hardware-management/pin-codes/new',
  hardwareDetailPinCodes: 'hardware-management/pin-codes/:pinCodeId',
};
